export enum SectionRestrictionTypeEnum {
	OrganizationPicker,
	Notifications,
	AddAccount,
	AuditLog,
}
